import { Stack } from 'react-bootstrap'
import React from 'react'
import { OverflowTooltip } from '../common/OverflowTooltip/OverflowTooltip'
import { MeetingTemplate } from '../../../../store/ai/meetingTemplate'

export interface MeetingTemplateDisplayProps {
  meetingTemplate: MeetingTemplate | null
}

export const MeetingTemplateDisplay: React.FC<MeetingTemplateDisplayProps> = ({ meetingTemplate }) => {
  return (
    <Stack direction='horizontal' gap={2}>
      <i className='bi-columns-gap icon' />
      <OverflowTooltip>
        <span className='paragraph-small'>{meetingTemplate?.name ?? '-'}</span>
      </OverflowTooltip>
    </Stack>
  )
}
